import React, { useMemo, useState } from "react";
import AppUnlockModal from "../components/common/AppUnlockModal";
import { HomePageMarketingFooter, HomePageMarketingHeader } from "../components/common/HomePageChrome";

const APP_DOWNLOAD_MODALS = {
  host: {
    title: "Become a Host",
    message:
      "List your club or event, reach nearby guests faster, manage bookings, and grow your nightlife business with VibeReserve.",
  },
  joinPromoter: {
    title: "Join a Promoter",
    message:
      "Connect with promoters, unlock exclusive events, and enjoy special perks by joining through the VibeReserve app.",
  },
  becomePromoter: {
    title: "Become a Promoter",
    message:
      "Promote clubs and events, grow your audience, and earn rewards with the VibeReserve promoter program.",
  },
};

function siteName() {
  return (process.env.REACT_APP_SITE_NAME || "Vibes Reserve").trim();
}

function bootstrapFooterFallback() {
  const year = new Date().getFullYear();
  const name = siteName();
  return (
    <footer className="site-footer border-top mt-auto">
      <div className="container py-4 px-3 px-md-4">
        <p className="site-footer__text mb-0 small text-center">
          © {year} {name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

/**
 * Website shell: marketing header/footer by default on all routes; optional overrides.
 *
 * Props:
 * - `beforeMain` — if **undefined**, renders marketing header when `marketingChrome` is true; pass explicit `null` for no header, or a React node for a custom header.
 * - `footerSlot` — if **undefined**, renders marketing footer when `marketingChrome` is true; pass a React node for a custom footer.
 * - `marketingChrome` — when false (and no overrides), restores simple Bootstrap-style footer only.
 */
export default function WebsiteLayout({
  children,
  beforeMain,
  footerSlot,
  marketingChrome = true,
}) {
  const [activeAppModal, setActiveAppModal] = useState(null);
  const appModalContent = useMemo(
    () => (activeAppModal ? APP_DOWNLOAD_MODALS[activeAppModal] : null),
    [activeAppModal]
  );

  const headerEl =
    beforeMain !== undefined
      ? beforeMain
      : marketingChrome && (
          <HomePageMarketingHeader
            onJoinPromoter={() => setActiveAppModal("joinPromoter")}
            onBecomePromoter={() => setActiveAppModal("becomePromoter")}
            onBecomeHost={() => setActiveAppModal("host")}
          />
        );

  const footerEl =
    footerSlot !== undefined ? footerSlot : marketingChrome ? <HomePageMarketingFooter /> : bootstrapFooterFallback();

  return (
    <div className="site-root d-flex flex-column min-vh-100">
      {headerEl}
      <main className="site-main flex-grow-1">{children}</main>
      {footerEl}
      {marketingChrome ? (
        <AppUnlockModal
          open={Boolean(appModalContent)}
          onClose={() => setActiveAppModal(null)}
          title={appModalContent?.title || "Unlock all features"}
          message={appModalContent?.message || ""}
        />
      ) : null}
    </div>
  );
}
